module.exports = __webpack_public_path__ + "static/media/example_symm2.131e5491.bmp";